import { render, staticRenderFns } from "./actividad-resultados-ars.vue?vue&type=template&id=a0bb1204&"
import script from "./actividad-resultados-ars.component.ts?vue&type=script&lang=ts&"
export * from "./actividad-resultados-ars.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports